import React from "react";
import Wrapper from "../../components/shared/Wrapper";

const WatchListCustomButton = (props) => {
  const {
    isLiveText,
    defaultSelected,
    fontSize,
    width,
    height,
    top,
    left,
    right,
    bottom,
    position,
    border,
    opacity,
    margincustom,
    display = "inline-flex",
    alignItems = "center",
    justifyContent = "center",
    style,
    type,
    onClick,
    onKeyDown,
    children,
    isCommingText,
    ...rest
  } = props;

  const styles = {
    button: {
      textAlign: isLiveText ? "left" : "center",
      border: border || "none",
      background: type === "referral-button"
        ? "none"
        : isLiveText 
        ? "rgb(255, 255, 255)"
        : defaultSelected
        ? "#EC008C"
        :isCommingText?"rgba(202, 202, 202, 1)"
        : "#0E1653",
      opacity: opacity || 1,
      borderRadius: "8px",
      color: type === "referral-button" && defaultSelected 
        ? "#EC008C" 
        : isLiveText 
        ? "#333" 
        : "#FFFFFF",
      fontSize: fontSize || "24px",
      fontFamily: "Anek Latin",
      cursor: "pointer",
      outline: "none",
      transition: "background 0.3s, border 0.3s",
      width: isLiveText ? "fit-content" : "fit-content" || "auto",
      height: height || "auto",
      marginTop: top,
      marginLeft: left,
      marginRight: right,
      marginBottom: bottom,
      position: position,
      display: display,
      alignItems: alignItems,
      justifyContent: justifyContent,
      padding: "10px 30px",
      whiteSpace: "nowrap",
      ...(position === "absolute" ? {} : { flexShrink: 0 }),
      ...style,
    },
  };

  return (


    <Wrapper
      as="button"
      style={styles.button}
      onClick={onClick}
      onKeyDown={onKeyDown}
      {...rest}
      type={type}
    >
      {children}
    </Wrapper>
  );
};

export default WatchListCustomButton;